<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 점검정보 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 점검정보</h5>

      <div class="writeGridContainer">
        <div>
          <div>담당부서</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_1 }}</p>
          <company-selector v-else v-model="form.inputA_0" :company-name="form.inputA_1" @select="targetCompany" :readonly="board.readonly" />
        </div>
        <div>
          <div>점검자명</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_2 }}</p>
          <ml-input v-else v-model="form.inputA_2" />
        </div>
        <div>
          <div>점검일</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_3 }}</p>
          <date-selector v-else :readonly="board.readonly" placeholder="날짜선택" v-model="form.inputA_3" />
        </div>
      </div>
    </div>

    <!-- 하반기 업무 수행 여부 -->
    <div>
      <vs-row class="my-4">
        <vs-col class="flex items-center">
          <h5><i class="dot"></i>하반기 업무 수행 여부</h5>
<!--          <div class="flex items-center cursor-pointer" @click="openPopup">-->
<!--            <feather-icon icon="AlertCircleIcon" class="ml-6 mr-1" style="cursor: pointer; width: 18px; color: #7e72f2" />-->
<!--            <span style="color: #7e72f2"> 이행사항 점검 시 작성요령 </span>-->
<!--          </div>-->
          <span class="ml-6">※ 점검표 입력 → PDF저장 → 공문시행 → 발송결재 공문 첨부</span>
        </vs-col>
      </vs-row>
      <table-inspect-no
        class="mt-5"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :is-show-title="false"
        :is-note="true"
        table-header-title="점검사항 및 세부내용"
        table-header-yes="이행"
        table-header-no="미이행"
        table-header-na="해당없음"
        table-header-note="비고(보완계획)"
        footer="※ (중처법=중대재해처벌 등에 관한 법률, 시특법=시설물의 안전 및 유지관리에 대한 특별법)"
        v-model="form.inspectList"
      />
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" />

    <!-- 이행사항 점검 시 작성요령 팝업 -->
    <vs-popup id="popAlert" title="이행사항 점검 시 작성요령" :active.sync="showPopup">
      <table id="PopupTable" style="margin-bottom: 20px">
        <tr>
          <th>증빙자료 첨부</th>
        </tr>
        <tr>
          <td class="p-3">
            <b class="mb-2 font-bold">점검결과 판단기준(연번 1~8번)</b>
            <ul>
              <li class="mb-1">1. 실시 : 점검항목을 100% 이행한 경우 (점검시점 기준)</li>
              <li class="mb-1">2. 미실시 : 점검항목을 이행 중이거나 이행하지 않은 경우</li>
              <li class="mb-1">3. 해당없음 : 점검항목과 무관한 경우</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td class="p-3 font-bold">반드시 디지털 안전보건 시스템(마엇)에 증빙자료 업로드 (업로드 매뉴얼 참고)</td>
        </tr>
        <tr>
          <td class="p-3">
            <b class="mb-2">작성요령</b>
            <ul class="tab-ul">
              <li class="mb-1">연번 1 : <span class="span-bl">시스템 ‘인력’</span> - 추가 인력 입력(관리부서, 수탁업체 인력 모두 입력 필수)</li>
              <li class="mb-1">연번 2 : <span class="span-bl">시스템 ‘예산’</span> - 12월 페이지에 예산 사용 금액 업로드 (2023년 계획 상 안전예산의 집행금액)</li>
              <li class="mb-1">
                연번 3 : <span class="span-bl">시스템 ‘시설물 안전점검(반기1회)’</span><br />
                <span style="padding-left: 47px">※ 정기안전점검, 정밀안전점검, 정밀안전진단 및 기타 개별법령에 따른 안전점검(소방시설 안전점검, 승강기 안전점검 등)</span>
              </li>
              <li class="mb-1">연번 4 : 전부서 ‘이행’으로 체크 C</li>
              <li class="mb-1">
                연번 5 : 가. <span class="span-bl">시스템 ‘유해위험요인 관리(수시) - (시설물)유해위험요인 페이지</span><br />
                <span style="padding-left: 64px">※ 동절기, 우기, 해빙기 등 수시 점검을 실시한 경우 점검표(결과보고서 등)를 해당 구분에 맞게 업로드</span><br />
                <span style="padding-left: 47px">나. 전부서 ‘이행’으로 체크</span><br />
                <span style="padding-left: 47px">다. 전부서 ‘이행’으로 체크</span><br />
                <span style="padding-left: 47px">라. 전부서 ‘이행’으로 체크</span>
              </li>
              <li class="mb-1">
                연번 6 : ① 부서별 변경사항이 없다면 이행으로 체크(평가절차 및 기준 표준안 배포-2023.2.27.)<br />
                <span style="padding-left: 47px">② <span class="span-bl">시스템 ‘도급용역위탁시 평가기준 및 절차 – 수급업체 안전보건 평가표 페이지</span></span
                ><br />
                <span style="padding-left: 64px"><span class="span-rd">※ 연1회 평가기준에 따라 도급·용역·위탁이 이루어지고 있는지를 점검해야 함.</span></span>
              </li>
              <li class="mb-1">
                연번 7 : 안전보건 관계 법령이란 시설물에 적용되는 모든 개별법령을 의미함(건축법, 재난안전법, 시특법, 도서관법 등)<br />
                <span style="padding-left: 47px" class="span-bl">※ 시설 담당자는 해당하는 개별법령을 확인하여 의무이행 여부를 자체적으로 점검하여야 함(붙임 파일 참고)</span>
              </li>
              <li class="mb-1">
                연번 8 : ① <span class="span-bl">시스템 ‘교육’</span> - 붙임파일 참고 <br />
                <span style="padding-left: 47px">② 미이수 사항 발견시 개선조치 계획 제출</span>
              </li>
            </ul>
          </td>
        </tr>
        <!--        연번 1  : 사업장을 담당하는 관리부서 담당자의 업무사항이 나와있는 자료(업무사항에 반드시 에 대한 내용이 명시되어 있어야 함</span>. 업무분장표를 제출할 경우, 하이라이트 등을 이용하여 담당자 명시 필수)-->
        <!--        <tr>-->
        <!--          <td style="text-align: center; font-size: 14px; line-height: 24px; color: #0029ff;font-weight: 700;padding: 14px;">-->
        <!--            * 필독!!<br/>-->
        <!--            자체점검 결과가 ‘보통’인 사항은 비고란에 <span style="color: #e42728; text-decoration: underline;">미이행사항 및 개선 조치 계획</span> 등을 기재,<br/>-->
        <!--            ‘미흡’인 사항에 대해서는 <span style="color: #e42728; text-decoration: underline;">미이행사항 및 개선 조치 계획</span>보완 조치 계획, 재점검 계획 등을 별도로 첨부</span>하여 제출-->
        <!--          </td>-->
        <!--        </tr>-->
      </table>
    </vs-popup>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspectNo from "@/components/TableInspectNo";
import DateSelector from "@/components/selector/DateSelector";
import CompanySelector from "@/components/selector/CompanySelector";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    TableInspectNo,
    DateSelector,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      showPopup: false,
      form: {
        stdInfo: {},
        fileList: [],
        inspectList: [
          {
            label: "필요한 안전인력 확보 [중처법 제10조제1호]",
            chlid: [
              {
                label: "시설·설비 안전보건 조치 업무 담당",
                is_checked: "",
              },
              {
                label: "시설·설비 유지보수 업무 관리",
                is_checked: "",
              },
            ],
          },
          {
            label: "필요한 안전예산 편성 및 집행 [중처법 제10조제2호]",
            chlid: [
              {
                label: "안전보건 관련 인건비",
                is_checked: "",
              },
              {
                label: "시설·장비 안전 확보 유지관리비",
                is_checked: "",
              },
              {
                label: "안전점검비",
                is_checked: "",
              },
              {
                label: "기타비용(보수·보강비 등)",
                is_checked: "",
              },
            ],
          },
          {
            label: "안전점검 계획 수립 및 시행 [중처법 제10조제3호]",
            chlid: [
              {
                label: "정기안전점검 계획 이행",
                is_checked: "",
              },
              {
                label: "정밀안전점검 이행 ",
                is_checked: "",
              },
              {
                label: "정밀안전진단 이행",
                is_checked: "",
              },
            ],
          },
          {
            label: "안전계획 수립 및 이행 [중처법 제10조제4호]",
            chlid: [
              {
                label: "인력 및 예산에 관한 사항",
                is_checked: "",
              },
              {
                label: "안전점검 또는 정밀안전진단의 실시에 관한 사항",
                is_checked: "",
              },
              {
                label: "보수·보강 등 유지관리에 관한 사항",
                is_checked: "",
              },
            ],
          },
          {
            label: "재해예방 업무처리 절차 마련·이행 [중처법 제10조제7호]",
            chlid: [
              {
                label: "유해·위험요인 점검 계획 이행",
                is_checked: "",
              },
              {
                label: "유해·위험요인 발견 시 조치 및 개선 절차 마련",
                is_checked: "",
              },
              {
                label: "재해 발생 시 대응 절차 및 매뉴얼 마련",
                is_checked: "",
              },
              {
                label: "비상대피훈련 계획 등(시특법 상 제1종 시설물)",
                is_checked: "",
              },
            ],
          },
          {
            label: "도급·용역·위탁 기준과 절차 마련·이행 [중처법 제10조제8호]",
            chlid: [
              {
                label: "도급·용역·위탁 시 평가기준 및 절차 마련",
                is_checked: "",
              },
              {
                label: "도급·용역·위탁 평가기준에 따라 수탁기관 점검",
                is_checked: "",
              },
            ],
          },
          {
            label: "기타 안전보건 관계 법령(시설물에 적용되는 개별 법령) 의무이행 점검 [중처법 제11조제2항제1호, 2호]",
            chlid: [
              {
                label: "의무이행사항 점검",
                is_checked: "",
              },
              {
                label: "미이행 사항 발견시 조치",
                is_checked: "",
              },
            ],
          },
          {
            label: "시설 안전관리자/종사자 의무교육 이행 점검 [중처법 제11조제2항제3호, 4호]",
            chlid: [
              {
                label: "교육 이수 대상 확정 및 이수 점검",
                is_checked: "",
              },
              {
                label: "미이수 사항 발견시 조치",
                is_checked: "",
              },
            ],
          },
        ],
        inputA_0: "",
        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: [],
      },
    };
  },
  methods: {
    openPopup() {
      this.showPopup = true;
    },
    targetCompany(value) {
      this.form.inputA_1 = value.com_name;
    },
  },
};
</script>

<style scoped lang="scss">
#PopupTable {
  width: 100%;
  border-collapse: collapse;

  &,
  tr,
  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 700;
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    background: #f9f9f9;
    padding: 10px 0;
  }

  li {
    margin-left: 16px;
    &::marker {
      content: " · ";
      font-size: 1.2em;
    }
  }
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
  word-break: keep-all;
}

.span-bl {
  color: #0029ff;
}
.span-rd {
  color: #ff0000;
}
</style>
